import {
  WorksheetImagesAndRemarksSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import { PageSection } from '../../../Layout';
import ids from '../../QestIds';
import { LiquidLimitMethodAPageSection, PlasticLimitPageSection, PreparationSection, ResultsSection } from './Sections';

const qestIds = [ids.atterbergLimit.AASHTO_T89_T90.methodA_Rev2013_2020];

let AtterbergLimitWorksheet: WorksheetRootComponent = () => {
  return (
    <>
      <PageSection heading="Preparation">
        <PreparationSection />
      </PageSection>
      <LiquidLimitMethodAPageSection />
      <PlasticLimitPageSection />
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <ResultsSection />
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

AtterbergLimitWorksheet.qestIds = qestIds;

export default AtterbergLimitWorksheet;
